<template>
  <div class="pa-2">
    Manage Academies
  </div>
</template>

<script>
//import Api2 from "@/services/Api2";

export default {
  data() {
    return {
      loading: true,
      federationsMode: 'federations',//If not federations, affiliations
    };
  },
  components: {
  },
  created() {
  },
  methods: {}
};
</script>

<style scoped></style>
